<template>
  <layout-basic>
    <v-container v-if="loading" grid-list-md fluid class="pt-3">
      <v-row>
        <v-col md="12">
          <v-skeleton-loader elevation="2" type="article"></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" class="pr-0">
          <v-container fluid class="pa-0">
          <v-layout wrap>
            <v-flex v-for="index in 6" :key="index" xs12 sm6 lg3 class="mb-5">
              <v-card :class="['card-outter', 'pb-0', { 'mr-6': isTabletOrDesktop }]" height="100%">
                <v-skeleton-loader elevation="2" class="card-loader"
                  type="list-item-two-line, image, list-item, button">
                </v-skeleton-loader>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else fluid class="text-left pt-3">
      <v-row>
        <v-col md="6" class="pa-0">
          <v-card flat style="background-color: transparent">
            <v-card-title class="text-wrap course-heading">
              {{ channel.name }}
            </v-card-title>
            <v-card-subtitle class="course-subhead">{{
              channel.description
            }}</v-card-subtitle>
            <v-icon
              color="secondary"
              class="fa super-size-icon ma-4 mt-0"
              tile
              size="120"
              v-if="channel.thumbnailOption == 'icon'"
              >fa-{{ channel.icon }}</v-icon
            >
            <v-img
              v-if="channel.thumbnailOption == 'image'"
              :src="imgSrc"
              class="white--text ml-3"
              height="120px"
              width="120px"
            />
          </v-card>
        </v-col>
        <v-col md="6"
          ><v-row>
            <v-col class="myplaylist-heading"> Additional Content </v-col>
          </v-row>
          <!--<v-card flat>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              :items="supplementalMaterial"
              item-key="id"
              hide-default-footer
            >
            <template class="vcard-list">
              <v-icon>fa-file</v-icon>
            </template>
            <template class="vcard-list">
              {{ item.file.data.original_name }}
            </template>
            </v-data-table>
          </v-card>-->

          <v-card class="ma-2 vcard-border" flat>
            <v-list
              v-for="(item, index) in supplementalMaterial"
              :key="index"
              dense
              class="pa-0"
            >
              <v-list-item
                
                v-if="index == 0"
                class="videoitem-content-th"
              >
                <template class="vcard-list">
                  <v-list-item-title style="width: 105px; flex: none">
                    <!-- Status -->
                  </v-list-item-title>
                  <v-list-item-title style="text-align: left">
                    <b>Title</b>
                  </v-list-item-title>
                  <v-list-item-title> &nbsp; </v-list-item-title>
                </template>
              </v-list-item>
              <v-list-item  class="vcard-list">
                <template class="videoitem-content-row">
                  <v-list-item-icon class="additionallisticon">
                    <v-icon style="color: #212121"
                      >fa fa-arrow-circle-right</v-icon
                    >
                  </v-list-item-icon>
                  <v-list-item-icon class="additionallisticon ml-5">
                    <v-icon style="color: #212121">{{
                      icon(item.file.data.mime_type)
                    }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content
                    class="ml-5 text-left"
                    style="min-width: 100px"
                  >
                    <v-list-item-title class="mr-3">{{
                      item.title
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      item.file.data.original_name
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-icon>
                    <v-btn
                      class="download-btn download-txt"
                      outlined
                      @click.prevent="viewAsset(item)"
                      v-if="item.file.data.mime_type != 'video/mp4'"
                    >
                      <v-icon small class="pr-2">fa-download</v-icon>
                      Download</v-btn
                    >
                    <v-btn
                      class="download-btn download-txt"
                      outlined
                      @click.prevent="playVideo(item)"
                      v-if="item.file.data.mime_type == 'video/mp4'"
                    >
                     <v-icon small class="pr-2">fa-play</v-icon>Play
                    </v-btn>
                  </v-list-item-icon>
                </template>
              </v-list-item>
              <v-divider
                v-if="index < supplementalMaterial.length - 1"
                :key="index"
              ></v-divider>
            </v-list>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <h2 class="ma-2 ml-0">Modules</h2>
          <v-flex xs12
                sm3
                lg3 class="course-filter">
          <v-select :items="categories" :clearable="true" item-text="name" item-value="id" ref="categoryFilterBox"
                placeholder="Filter course categories" multiple small-chips class="categories" v-model="selectedCategory"
                v-on:change="filterCoursesByCategories($event)" menu-props="content-class: dropdown-below" @click:clear="handleClear">
                <template v-slot:selection="{ item, index }">
                <template v-if="index < 2">
                  <v-chip :title="item.name">{{ $gf.truncateText(item.name, 6) }}</v-chip>
                </template>
                <template v-if="index === 2">
                  <v-chip>...</v-chip>
                </template>
              </template>
                <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleSelectAll">
              <v-list-item-action>
                <v-checkbox :input-value="selectAll" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Select All</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
          </v-select> 
        </v-flex>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-container fluid class="pa-0">
            <v-layout wrap>
              <v-flex
                v-for="module in modules"
                :key="module.id"
                xs12
                sm6
                lg3
                class="mb-5 pa-2"
              >
                <course-card :course="module" :mini="true"></course-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="isOpen" max-width="750px" persistent>
      <v-card>
        <v-card-title class="dialog-title">
          <span>{{ this.contentTitle }}</span>
        </v-card-title>
          <v-container class="dialog-container">
            <v-row justify="center">
              <v-col lg="10" md="10" sm="10">
                <video-player
                  ref="videoPlayer"
                  :playsinline="true"
                  :options="playerOptions"
                  class="vjs-big-play-centered mt-3"
                  style="border:3px solid #162b44;"
                  v-if="this.videoUrl !=''"
                />
                </v-col>
                </v-row>
            </v-container>
        <v-card-actions class="btn-section">
          <v-btn class="mr-1 mb-2 add-course-button"
          color="primary" outlined @click="closeDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </layout-basic>
</template>
<script>
import { IMPROVE_CONFIG } from '@/config.js';
import LayoutBasic from '@/layouts/Dashboard';
import channelAPI from '@/api/channel.js';
import thumbSizes from '@/utils/thumbs.js';
import CourseCard from '@/components/global/CourseCard';
import courseAPI from "@/api/course.js";
import { videoPlayer } from 'vue-video-player';

export default {
  name: 'ChannelDetails',
  components: {
    LayoutBasic,
    CourseCard,
    videoPlayer,
  },
  data() {
    return {
      headers: [
        {
          text: 'Status',
          value: 'status',
          sortable: false,
        },
        { text: '', value: '', sortable: false, class: '' },
        { text: 'Title', value: 'title', sortable: false, class: '' },
        //{ text: "Action", value: "id", sortable: false, align: "left" }
        { text: '', value: '', sortable: false, class: '' },
      ],
      channel: [],
      channelAssets: [],
      supplementalMaterial: [],
      modules: {},
      courses: [],
      loading: false,
      id: this.$route.params.id,
      params: '?include=publishedmodules',
      categories: [],
      selectedCategory: [],
      contentTitle: '',
      isOpen: false,
      videoUrl: '',
    };
  },
  computed: {
    imgSrc: function () {
      if (
        this.channel.thumbnailOption == 'image' &&
        this.channel.thumbnail.hasOwnProperty('data')
      ) {
        const imageRequest = JSON.stringify({
          bucket: `${IMPROVE_CONFIG.BUCKET}`,
          key: this.channel.thumbnail.data.key,
          edits: thumbSizes.thumb,
        });
        const url = `${IMPROVE_CONFIG.SERVERLESS_IMAGE_HANDLER}/${btoa(
          imageRequest
        )}`;
        return url;
      }
      return '';
    },
    selectAll() {
      return this.selectedCategory.length === this.categories.length;
    },
    isTabletOrDesktop() {
            const width = this.$vuetify.breakpoint.width;
            return width >= 820;
    },
    playerOptions: function() {
      return {
        autoplay: false,
        preload: 'auto',
        responsive: true,
        aspectRatio: '16:9',
        controls: true,
        sources: [
          {
            type: 'video/mp4',
            src: this.videoUrl,
          },
        ],
      };
    },
     player() {
      return this.$refs.videoPlayer.player;
    },
  },
  mounted() {
    this.getChannel();
    this.getAllCourseCategories();
  },
  methods: {
    viewAsset(item) {
      window.open(item.file.data.url, '_blank');
    },
    getChannel() {
      this.loading = true;
      channelAPI.getChannel(this.id, this.params).then((response) => {
        this.loading = false;
        this.channel = response.data.data;
        this.modules = response.data.data.publishedmodules.data;
        this.supplementalMaterial =
          response.data.data.supplementalMaterial.data;
      });
    },
    icon(mimeType) {
      var icon = '';
      switch (mimeType) {
        case 'video/mp4':
          icon = 'fa-video';
          break;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          icon = 'fa-file-word';
          break;
        case 'image/jpeg':
        case 'image/png':
          icon = 'fa-image';
          break;
        case 'application/pdf':
          icon = 'fa-file-pdf';
          break;
        default:
          icon = 'fa-file';
          break;
      }
      return icon;
    },
    getAllCourseCategories() {
        courseAPI.getAllCourseCategories().then(response => {
            this.categories = response.data.data;
        });
        },
    filterCoursesByCategories(){
      if (this.selectedCategory.length) {
        this.params += '&categories=' + this.selectedCategory.toString();
      }else{
        this.params = '?include=publishedmodules';
      }
      this.getChannel();      
    },
    handleClear(){
      const dropdown = this.$refs.categoryFilterBox.$el;
      dropdown.style.removeProperty("overflow");
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedCategory = [];
      } else {
        this.selectedCategory =  this.categories.map((cat) => cat.id);
      }

      this.filterCoursesByCategories()
    },
    playVideo(data) {
      this.contentTitle = data.title;
      this.videoUrl = data.file.data.url;
      this.isOpen = true;
      document.getElementById('improve').style.pointerEvents = 'none';
      document.getElementById('navbar-collapse').style.pointerEvents = 'none';
    },
    closeDialog() {
      document.getElementById('improve').style.pointerEvents = 'unset';
      document.getElementById('navbar-collapse').style.pointerEvents = 'unset';
      this.isOpen = false;
      this.player.currentTime(0);
      this.player.pause()
      this.videoUrl = '';
    },
  },
};
</script>
<style>
.super-size-icon {
  font-size: 150px !important;
}
</style>
